<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: lau
 * @Date: 2023-05-11 16:45:31
 * @LastEditors: lau
 * @LastEditTime: 2023-05-12 15:15:10
-->
<!-- 查询账单开票状态 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody:{
                bills: [
                    {
                        "parkCode":"2KKN6112",
                        "billCode":"2023051114363066769660",
                        "billType":"0"
                    }
                ]
             },
            responseCode: {
                "data": {
                    "recordList": [
                            {
                                "parkCode":"2KKN6112",
                                "billCode":"2023051114363066769660",
                                "topBillCode":"2023051114363066769660",
                                "realValue":"0.01",
                                "billType":"0"
                            }
                        ]
                },
                "message": "开票成功",
                "resultCode": 900,
                "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台查询账单开票状态，响应可以开票的订单",
                t_url: this.commonUrls.test + "listInvoiceStatus",
                p_url: this.commonUrls.prod + "listInvoiceStatus",
                precondition: "无",
                fitSystem: "VEMS传统停车场, 云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'bills', info2: '是', info3: 'JSONArray', info4: '账单列表' },                        

                    ]
                },{
                    titleName: 'bills',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编号' },             
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '账单流水号' },
                        { info1: 'billType', info2: '是', info3: 'Integer', info4: '账单类型  0停车费,1月票' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '可以开票的账单列表' },                        

                    ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编号' },             
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '账单流水号' },
                        { info1: 'topBillCode', info2: '是', info3: 'String', info4: '顶级流水号' },
                        { info1: 'realValue', info2: '是', info3: 'DECIMAL', info4: '实际金额，单位：元' },
                        { info1: 'billType', info2: '是', info3: 'Integer', info4: '账单类型  0停车费,1月票' },
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/invoice/listInvoiceStatus.vue